import { Link } from "react-router-dom";
import { routes, FreetypeSearchType } from "@/common/utils/routes";
import NoResultsIcon from "./images/icons/no-results.svg?react";
import "./FreeTextCard.scss";

interface IFreeTextCard {
  text: string;
  onClick?: () => void;
}

export const FreeTextCard = ({
  text,
  onClick
}: IFreeTextCard) => {
  return (
    <Link to={routes.freetypeSearch(FreetypeSearchType.creators, { query: text })} onClick={onClick} aria-label={`Search for ${text}`} className="freeTextCard">
      <div className="freeTextIcon"><NoResultsIcon /></div>
      <span className="freeText">{text}</span>
    </Link>
  );
};
